
import { Component, Vue } from 'vue-property-decorator';
import { getInstallScourceList, addInstallScource, delInstallScource, editInstallScource } from '@/api/installScource';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'OrderInstallSource',
  components: {

  }
})
export default class extends Vue {
  private tableData = []
  private installScourceName=''
  private addInstallScourceVisible=false
  private installSourceId=''
  // 分页处理
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }

  created() {
    this.getInstallScourceList();
  }
  private handleCurrentChange(page: number) {
    this.pagination.currentPage = page;
    this.getInstallScourceList();
  }
  private handlePageSizeChange(size: number) {
    this.pagination.size = size;
    this.getInstallScourceList();
  }
  private sourceHandle() {
    this.installScourceName = '';
    this.installSourceId = '';
    this.addInstallScourceVisible = true;
  }
  private editHandle(val:any) {
    this.installScourceName = val.name;
    this.installSourceId = val.id;
    this.addInstallScourceVisible = true;
  }
  private deleteHandle(val:any) {
    this.$confirm('是否删除?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.delInstallScource(val.id);
      })
      .catch(() => {});
  }
  private delInstallScource(installSourceId:any) {
    let paramters:any = {};
    paramters.user_id = UserModule.getUserId;
    paramters.company_id = UserModule.getCompanyId;
    paramters.install_source_id = installSourceId;
    delInstallScource(paramters).then(res => {
      this.showSecussMsg((res as any).msg);
      this.getInstallScourceList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private addInstallScourceClick() {
    if (!this.installScourceName) {
      this.showErrorMsg('请输入安装来源');
      return;
    }
    this.addInstallScource(this.installSourceId);
  }
  private addInstallScourceCancleClick() {
    this.addInstallScourceVisible = false;
  }

  private addInstallScource(installSourceId:string) {
    let paramters:any = {};
    paramters.user_id = UserModule.getUserId;
    paramters.company_id = UserModule.getCompanyId;
    paramters.name = this.installScourceName;
    if (!installSourceId) {
      addInstallScource(paramters).then(res => {
        this.showSecussMsg((res as any).msg);
        this.addInstallScourceVisible = false;
        this.getInstallScourceList();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else {
      paramters.install_source_id = installSourceId;
      editInstallScource(paramters).then(res => {
        this.showSecussMsg((res as any).msg);
        this.addInstallScourceVisible = false;
        this.getInstallScourceList();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }
  private getInstallScourceList() {
    let paramters:any = {};
    paramters.user_id = UserModule.getUserId;
    paramters.company_id = UserModule.getCompanyId;
    paramters.page = this.pagination.currentPage;
    paramters.size = this.pagination.pageSize;

    getInstallScourceList(paramters).then(res => {
      if (res.data) {
        this.tableData = res.data.list;
        this.pagination.total = parseInt(res.data.count);
      } else {
        this.tableData = [];
      }
    }).catch(err => {
      let msg = err.msg;
      this.tableData = [];
      this.pagination.total = 0;
      this.pagination.currentPage = 1;
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
